import Vue from 'vue'

// External plugins
import VueMeta from 'vue-meta'
import InfiniteLoading from 'vue-infinite-loading'

// Custom plugins
import isNavbar from '@/plugins/is-navbar'
import ModalPlugin from '@/plugins/modal'
import WaveButton from '@/plugins/wave-button'
import Route from '@/plugins/route'
import WithLoading from '@/plugins/with-loading'
import FileSaver from '@/plugins/file-saver'
import DomUtils from '@/plugins/dom-utils'

import './amplify'
import './global'
import './polyfills'

Vue.use(VueMeta, { refreshOnceOnNavigation: true })
Vue.use(isNavbar)
Vue.use(ModalPlugin)
Vue.use(WaveButton)
Vue.use(Route)
Vue.use(WithLoading)
Vue.use(FileSaver)
Vue.use(DomUtils)
Vue.use(InfiniteLoading, { slots: { noResults: '', noMore: '' } })
